import {
  Linking,
  Platform,
} from 'react-native';
import { Theme, themeColorSet, ThemedPressable, ThemedText, ThemedView } from '../../theme';
import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { PrivateStackParamList } from '../../navigationApp/types';
import EmailIcon from '../../../assets/Icons/Email';
import { CaretRight } from '../../sharedComponents/Icons';
import WhatsAppIcon from '../../../assets/Icons/Whatsapp';
import PhoneIcon from '../../../assets/Icons/PhoneIcon';
import { useAppSelector } from '@app/store/hooks';
import CommonHeader from '@app/sharedComponents/CommonHeader/CommonHeader';
import { useIsEnhanceLimit } from '@app/hooks/useIsEnhanceLimit';
import { useTheme } from '@shopify/restyle';
import { showWhatsappButton, trackEvent } from '@app/utils';

type ScreenProps = NativeStackScreenProps<PrivateStackParamList, 'CONTACT_US'>;


const ContactUs = ({ navigation , route, props }: ScreenProps) => {
  const {platformParams} = useAppSelector((state) => state); 
  const { emailData,waData,showCall,callData, showWA ,platform} = platformParams;

  const { colors } = useTheme<Theme>();

  const getContactNumberForCall = (defaultNum:string) =>{
    if (platform === 'FREO') {
      return '+916364465607'
    } else {
        return defaultNum
    }
  }

  const { isEnhanceOrElevate} = useIsEnhanceLimit();

  const showWhatsApp = showWhatsappButton(showCall,platform);

  const getContactNumberForWhatsapp = (defaultNum: string) => {
    if (platform === 'FREO') {
        return '916364465607'
    } else {
        return defaultNum
    }
  }

  const onWhatsappPress = () => {
    const waNum = getContactNumberForWhatsapp(waData)
    if (Platform.OS === 'web') {
      window.open(`https://wa.me/${waNum}`, '_blank');
    } else {
      Linking.openURL(`whatsapp://send?phone=+${waNum}&text=Hi`);
    }
  };

  const onEmailPress = () => {
    if (Platform.OS === 'web') {
      window.open(`mailto:${emailData}`, '_blank');
    } else {
      Linking.openURL(`mailto:${emailData}`);
    }
  };

  const onCallPress = () => {
    if (Platform.OS === 'web') {
      window.open(`tel:${callData}`,'_parent');
    } else {
      Linking.openURL(`tel:${callData}`);
    }
  }

  trackEvent('NEED_HELP_BOTTOMSHEET_PAGEVIEWED');

  const details = (
    <ThemedView padding="lg">
    <ThemedText variant='b2b' color='text-primary'>
      Reach out to us
    </ThemedText>
    <ThemedView mb="xs" mt="sm">
      <ThemedText variant='b3r' color='text-secondary'>
      We would love to hear from you. You can get back to us via WhatsApp{showCall && ', Call,'} or Email.
      </ThemedText>
    </ThemedView>
    {showWhatsApp && <ThemedPressable 
      flexDirection='row' 
      justifyContent='space-between' 
      alignItems='center'
      mt="md"
      p="lg"
      borderRadius='md'
      borderWidth={1}
      borderColor='bg-fill-emphasis-primary-1'
      backgroundColor='bg-surface-primary'
      onPress={onWhatsappPress}
      eventName='NEED_HELP_WHATSAPP_CLICKED'
      >
        <ThemedView
          flex={1}
          flexDirection='row'
          flexShrink={1}
          alignItems='center'>
          <WhatsAppIcon size={24} />
          <ThemedView mx="md" flex={1} flexShrink={1}>
            <ThemedText variant="b3s" color="text-primary" mb="xs">
              WhatsApp us
            </ThemedText>
            <ThemedText variant="b4r" color="text-secondary">
              We usually reply within 5-10 mins. We’re available on Mon-Sat from 9:30 AM to 6:30 PM
            </ThemedText>
          </ThemedView>
        </ThemedView>
        <CaretRight size={16} color="rgb(20, 52, 203)" />
    </ThemedPressable>}
    {(showCall || isEnhanceOrElevate) &&
      (<ThemedPressable 
        eventName='NEED_HELP_PHONE_CLICKED'
        flexDirection='row' 
        justifyContent='space-between' 
        alignItems='center'
        mt="md"
        p="lg"
        borderRadius='md'
        borderWidth={1}
        borderColor='bg-fill-emphasis-primary-1'
        backgroundColor='bg-surface-primary'
        onPress={onCallPress}>
        <ThemedView
          flexDirection='row'
          alignItems='center'
          flexShrink={1}
          flex={1}>
          <PhoneIcon color={colors['icon-primary']} size={24} />
          <ThemedView mx="md" flex={1} flexShrink={1}>
          <ThemedText variant="b3s" color="text-primary" mb="xs">
          Call us
          </ThemedText>
          <ThemedText variant="b4r" color="text-secondary" mb="xs">
          {`Call us at ${getContactNumberForCall(callData)}. We’re available on Mon-Sat from 9:30 AM to 6:30 PM`}
          </ThemedText>
          </ThemedView>
        </ThemedView>
        <CaretRight size={16} color="rgb(20, 52, 203)" />
      </ThemedPressable>)}
      <ThemedPressable 
        eventName='NEED_HELP_EMAIL_CLICKED'
        flexDirection='row' 
        justifyContent='space-between' 
        alignItems='center'
        mt="md"
        p="lg"
        borderRadius='md'
        borderWidth={1}
        borderColor='bg-fill-emphasis-primary-1'
        backgroundColor='bg-surface-primary'
        onPress={onEmailPress}>
        <ThemedView
          flex={1}
          flexShrink={1}
          flexDirection='row'
          alignItems='center'>
          <EmailIcon size={24} bgColor={'transparent'} color={themeColorSet['icon-action-primary']} />
          <ThemedView  flex={1} flexShrink={1} mx="md">
          <ThemedText variant="b3s" color="text-primary" mb="xs">
            Email us
          </ThemedText>
          <ThemedText variant="b4r" flexWrap='wrap' color="text-secondary">
          {`Email us at ${emailData}. We usually respond within 2 hours`}
          </ThemedText>
          </ThemedView>
        </ThemedView>
        <CaretRight size={16} color="rgb(20, 52, 203)" />
      </ThemedPressable>
    
  </ThemedView>
  )
  if(route===undefined){
    return details
  }
  return (
    <>
    <CommonHeader navigation={navigation} pageName="CONTACT_US" label="Contact us" showNeedHelp={false} hideBackButton={route?.params?.showBackIcon}  />
    <ThemedView bg="bg-surface-primary" flex={1}>
      {details}
    </ThemedView>
    </>
  );
};

export default ContactUs;

